module.exports = __webpack_public_path__ + "static/media/403-forbidden.6f6fd404.svg";